var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.isUser)?_c('button',{class:_vm.btnClass,on:{"click":function($event){$event.preventDefault();return _vm.blockUnblock($event)}}},[_vm._v(" "+_vm._s(_vm.blocking ? 'Unblock' : 'Block')+" ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }